import { FunctionComponent } from 'react';
import { twMerge } from 'src/utils/twMerge';

import { createCdnIcon } from 'src/designSystem/CdnIcon';

const FreezeIcon = createCdnIcon('streak/day-freeze.svg');

type Props = {
  held: number;
  cap: number;
  size: 'small' | 'large';
};
export type { Props as StreakFreezeSlotsProps };

const LOOK = {
  small: {
    slot: 'h-10 w-10 rounded-lg',
    empty: 'border border-dashed border-textBlue',
    icon: 'h-8',
    gap: 'gap-1',
  },
  large: {
    slot: 'h-16 w-16 rounded-xl',
    empty: 'border-2 border-dashed border-secondary-lighter',
    icon: 'h-[50px]',
    gap: 'gap-2',
  },
} as const;

const StreakFreezeSlots: FunctionComponent<Props> = ({ held, cap, size }) => {
  const look = LOOK[size];

  return (
    <div className={twMerge('flex shrink-0 items-center justify-center', look.gap)}>
      {Array.from({ length: cap }, (_, index) =>
        index < held ? (
          <div
            key={index}
            data-testid="streak-freeze-slot-filled"
            className={twMerge(
              'flex items-center justify-center bg-secondary-lightest',
              look.slot,
            )}
          >
            <FreezeIcon className={twMerge('w-auto', look.icon)} />
          </div>
        ) : (
          <div
            key={index}
            data-testid="streak-freeze-slot-empty"
            className={twMerge(look.slot, look.empty)}
          />
        ),
      )}
    </div>
  );
};

export default StreakFreezeSlots;
